import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../../api/quarkusApi';

const authHeader = () => ({ headers: { Authorization: sessionStorage.getItem('token') } });

export function usePatients() {
  const navigate = useNavigate();

  const [patients, setPatients] = useState([]);
  const [paginationCount, setPaginationCount] = useState(0);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleError = useCallback(
    (returnFromApi) => {
      setError(returnFromApi.response?.data);
      console.error('ops! ocorreu um erro' + returnFromApi);
      if (returnFromApi.status === 401) {
        navigate('/expired-session');
      }
    },
    [navigate],
  );

  const fetchAll = useCallback(() => {
    setLoading(true);
    quarkusApi
      .get('/patients', authHeader())
      .then((returnFromApi) => {
        setPaginationCount(returnFromApi.data.totalPages);
        setPatients(returnFromApi.data.content);
      })
      .catch(handleError)
      .finally(() => setLoading(false));
  }, [handleError]);

  const fetchByPage = useCallback(
    (page, nameOrCpf) => {
      setLoading(true);
      quarkusApi
        .get('/patients', {
          ...authHeader(),
          params: { nameOrCpf: nameOrCpf || '', page: page - 1, size: 5 },
        })
        .then((returnFromApi) => {
          setPaginationCount(returnFromApi.data.totalPages);
          setPatients(returnFromApi.data.content);
        })
        .catch(handleError)
        .finally(() => setLoading(false));
    },
    [handleError],
  );

  const searchByNameOrCpf = useCallback(
    (nameOrCpf) => {
      setLoading(true);
      quarkusApi
        .get('/patients/search', { ...authHeader(), params: { nameOrCpf } })
        .then((returnFromApi) => {
          setPaginationCount(returnFromApi.data.totalPages);
          setPatients(returnFromApi.data.content);
        })
        .catch(handleError)
        .finally(() => setLoading(false));
    },
    [handleError],
  );

  useEffect(() => {
    fetchAll();
  }, [fetchAll]);

  return { patients, paginationCount, isLoading, error, fetchAll, fetchByPage, searchByNameOrCpf };
}
